export const LABELS = {
  TITLE: (name: string) => `Congrats ${name}, your application has been accepted`,
  SUBTITLE: 'Review & sign your tenancy agreement',
  GET_STARTED: 'Sign now',
  QUICK_START: 'Quick start',
  CREATE_DRAFT: 'Create your first draft-application',
  COMPLETE_PROFILE: 'Complete profile',
  SUBMIT: 'Submit your first application',
};
